import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './styles/landing.css'
import { registerWebMCP } from './webmcp'

// Redirect tamerin-ki.de to art.tamerintech.com
if (window.location.hostname === 'tamerin-ki.de' || window.location.hostname === 'www.tamerin-ki.de') {
  window.location.replace('https://art.tamerintech.com/');
}

// Expose site actions to AI agents via WebMCP (no-op where unsupported).
registerWebMCP()

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Missing #root')
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

if (rootElement.dataset.prerender === 'true') {
  hydrateRoot(rootElement, app)
} else {
  createRoot(rootElement).render(app)
}
